import React from "react";

const WorkbayMap = (props) => {
    return (
            <div className="technicianMap"><img alt="Workbay" src={props.technician.workshopBay.imageUri}></img></div>
        ); 
};
export default WorkbayMap;